import React, { useState, useEffect, useRef } from "react";
import "./Footer.css";
import { FaInstagram, FaYoutube, FaFacebookF, FaSpotify, FaTiktok } from "react-icons/fa";
import { getPoliticas, isApiConfigured } from "../services/api";

// Enlaces de respaldo, usados mientras no haya API configurada o hasta que
// responda /balloon-ben/v1/politicas. Una vez llega la respuesta del CMS,
// esta lista se reemplaza con las políticas reales (así agregar/editar/
// reordenar una política desde el plugin se refleja aquí sin tocar código).
const politicasFallback = [
  { slug: "aviso-de-privacidad-autorizacion-datos-personales", titulo: "Aviso de privacidad y autorización de datos" },
  { slug: "politica-habeas-data", titulo: "Política de habeas data" },
  { slug: "cookies", titulo: "Cookies" },
  { slug: "condiciones-de-uso", titulo: "Condiciones de uso" },
];

const Footer = () => {
  const [politicas, setPoliticas] = useState(politicasFallback);
  const fetched = useRef(false);

  useEffect(() => {
    if (!isApiConfigured() || fetched.current) return;
    fetched.current = true;

    getPoliticas()
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setPoliticas(data);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <footer className="footer">
      <div className="footer-socials">
        <a href="https://www.instagram.com/balloonandben/"><FaInstagram /></a>
        <a href="https://www.youtube.com/@BalloonAndBen"><FaYoutube /></a>
        <a href="https://www.facebook.com/BalloonAndBen"><FaFacebookF /></a>
        <a href="https://open.spotify.com/intl-es/artist/70LxuyrSqLkYRVuvT8fhyn"><FaSpotify /></a>
        <a href="https://www.tiktok.com/@balloonandben"><FaTiktok /></a>
      </div>

      <div className="footer-links">
        {politicas.map((p) => (
          <a key={p.slug} href={`/politicas/${p.slug}`}>
            {p.titulo}
          </a>
        ))}
      </div>

      <p className="footer-copy">Balloon & Ben Copyright 2025</p>
    </footer>
  );
};

export default Footer;

